import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from 'react-fa'
import './FilterRemoveButton.scss'

class FilterRemoveButton extends PureComponent {
  render() {
    const drawerClasses = classNames({
      'filter-remove-button__filter-name-drawer': true,
      'filter-remove-button__filter-name-drawer--open': true,
      'filter-remove-button__filter-name-drawer--no-icon': !this.props.getIcon || !this.props.getIcon()
    })

    return (
      <div className='filter-remove-button'>
        { this.props.getIcon && this.props.getIcon() }
        <div className={drawerClasses}>
          <Icon
            className='filter-remove-button__filter-delete'
            name='remove'
            onClick={() => this.props.onRemove()}
            title={'Remove Filter'} />
          <span className='filter-remove-button__filter-name'>{this.props.filterName}</span>
        </div>
      </div>
    )
  }
}

FilterRemoveButton.propTypes = {
  filterName: PropTypes.string.isRequired,
  getIcon: PropTypes.func,
  onRemove: PropTypes.func.isRequired
}

export default FilterRemoveButton



// WEBPACK FOOTER //
// ./src/components/FilterRemoveButton/FilterRemoveButton.js